<ng-container *transloco="let t">
  @if (isHorizontalMode) {
    <div
      class="horizontal-mode mb-4 d-flex flex-column flex-md-row align-items-center justify-content-center flex-column-reverse">
      <div class="d-flex flex-column">
        <div class="fs-44-32 fw-semibold">{{ t('emptyState.sorry') }}</div>
        <div class="fs-18-16 pb-3">{{ t('emptyState.not.able.to.find') }}</div>
        <div class="">
          {{ t('emptyState.do.not.worry') }}
        </div>
        <div [innerHTML]="formattedMessage"></div>
      </div>
      <div class="ms-0 ms-md-5 pb-4">
        <img src="assets/img/empty-state.svg" alt="Empty state" class="img-fluid ms-0 ms-md-2" width="180" height="180">
      </div>
    </div>
  } @else {
    <div [class.pb-300-228]="addPaddingBottom">
      <app-grey-card-with-title [title]="t('emptyState.sorry')" [removeContentPaddingTop]="true" [showLogo]="false">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <div class="fs-18-16 pt-0-48">{{ t('emptyState.not.able.to.find') }}</div>
          <div class="pt-16-30">
            <img src="assets/img/empty-state.svg" alt="Empty state" class="img-fluid">
          </div>
          <div class="pt-27-58">
            {{ t('emptyState.do.not.worry') }}
          </div>
          <div>
            <div [innerHTML]="formattedMessage" class="text-center"></div>
          </div>
        </div>
      </app-grey-card-with-title>
    </div>
  }
</ng-container>
